cwAdr.listIsOut = false;
$(document).ready(function () {

     $('#PlanCmentarza').css('height',$(window).height());
    var panZoomTiger = svgPanZoom('#PlanCmentarza', {
                                  zoomScaleSensitivity: 0.5,
                                  minZoom: 1,
                                  maxZoom: 5
                                });

 
    $('.cwadrPaths').mouseenter(function(){
        var th = $(this);
        var myObject = { prop1: 4};
        
        anime({
            targets: myObject,
            prop1:9,
            update: function (anim) {
                th.find('circle').attr({ r: myObject.prop1 })
            },
            duration: 100,
            easing: 'linear'
        });
    });

    $('circle').click(function(){
         var th   = $(this),
            kwat = th.attr('kwat'),
            row  = th.attr('row'),
            grave = th.attr('grave');
            fillGrave(kwat,row, grave);
            if(cwAdr.listIsOut == false){
                anime({
                    targets: '.cwadr-map-title',
                    translateX: '-20rem',
                    easing: 'easeInOutQuad',
                    duration: 350,
                    complete: function (anim) {
                        cwAdr.listIsOut = true;
                        anime({
                            targets: '.cwadr-map-list',
                            translateX: ['-20rem','0'],
                            duration: 350,
                            delay: 100,
                            easing: 'easeInOutQuad'
                        });
                    }
                });  
            }

    });

    // Przycisk zamykajacy listę
    $('.cwadr-map-list-title > button').click(function(){
        anime({
            targets: '.cwadr-map-list',
            translateX: ['0', '-20rem'],
            duration: 350,
            delay: 100,
            easing: 'easeInOutQuad',
            complete: function (anim) {
                cwAdr.listIsOut = false;
                anime({
                    targets: '.cwadr-map-title',
                    translateX: '-1rem',
                    easing: 'easeInOutQuad',
                    duration: 250,
                    complete: function (anim) {
                        $('.cwadr-map-title').attr('style','');
                    }
                });
            }
        });

    });


    $('.cwadrPaths').mouseleave(function () {
        var th = $(this);
        var myObject = { prop1: 9 };
        anime({
            targets: myObject,
            prop1: 4,
            update: function (anim) {
                th.find('circle').attr({ r: myObject.prop1 })
            },
            duration: 100,
            delay: 100,
            easing: 'linear'
        });
    });
});

function fillGrave(kwat,row, grave) {
    addLoader('#cwadr-plan-grave-content');
    $.ajax({
        dataType: "json",
        type: "POST",
        url: wrdPress.ajaxUrl,            
        cache: false,
        data: { 'action': 'get_grave', 'kwat':kwat, 'row':row, 'grave':grave },
        success: function (data) {
            removeLoader();
            console.log(data);
            fillGraveDit(data,kwat,row,grave);
        },
        error: function (data) {

            console.log(data);

        }
    });
}

function fillGraveDit(data,kwat,row,grave){
    console.log(data);
    var output = '',
        l_zn   = parseInt(data.l_zniczy),
        cls    = l_zn > 100 ? 'candle-s-3' : l_zn > 30 ? 'candle-s-2' : 'candle-s-1';

        output += '<div class="row small-12 columns" id="cwadr-plan-kwatera">';
        output +=  '<dl class="medium-4 small-12 columns">';
        output +=  '<dt>Kwatera</dt>';
        output +=  '<dd>' + kwat +'</dd>';
        output +=  '</dl>';
        output +=  '<dl class="medium-4 small-12 columns">';
        output +=  '<dt>Rząd</dt>';
        output +=  '<dd>' + row +'</dd>';
        output +=  '</dl>';
        output +=  '<dl class="medium-4 small-12 columns">';
        output +=  '<dt>Grób</dt>';
        output +=  '<dd>' + grave +'</dd>';
        output +=  '</dl>';
        output +=  '</div>';

        if(jQuery.isEmptyObject(data)){
            1
        }else{
            output += "<hr class='cwadr-hr'>";
            output += "<a href='" + data.wizerunek_f + "' data-lightbox='image' >";
            output += "<img src='" + data.wizerunek_l + "'>";
            // output += "<div class='cwadr-gallery-effect'></div>";
            // output += "<div class='cwadr-gallery-effect-2'><div><i class='fa fa-search fa-2x' aria-hidden='true'></i></div></div>";
            output += "</a>";
            if(data.opis != ''){
                output += "<hr class='cwadr-hr' style='margin-top: 0.5rem;'>";
                output += '<p class="cwadr-plan-content-dit" >' + data.opis + '</p>';
            }

        } 
        // output += '<div class="cwadr-znicze row"><h3 class="cwadr-znicze-txt">Zapalone znicze:</h3><div class="row cwadr-fire-candle"><div class="candle candle-a-1 candle-s-1"><div class="flame-1 flame"></div><div class="flame-2 flame"></div><div class="flame-3 flame"></div><div class="flame-4 flame"></div></div><img class="candle-img-xl" src="http://localhost/cmentarz/wp-content/themes/cwadr/img/lanternxl.png"></div><h2 class="cwadr-znicze-txt">1</h2><div class="row cwadr-znicze-btn"><button class="hollow button secondary" id="light-candle-modal"><i class="fa fa-fire" aria-hidden="true"></i> Kliknij i zapal swój znicz</button></div></div>';

        output += '<div class="cwadr-candle-on-img-container" >';
        output += '<div class="cwadr-candle-on-img" >';
        output += '<div class="cwadr-fire-candle">';
        if(l_zn != 0){
            output += '<div class="cwadr-modal-fire-candle-s-3 candle candle-a-1 ' + cls + '"><div class="flame-1 flame"></div><div class="flame-2 flame"></div><div class="flame-3 flame"></div><div class="flame-4 flame"></div></div>';
            output += '<img class="candle-img-xl" src="'+wrdPress.templateUrl+'/img/lanternxl.png">';
            output += '</div>';   
            output += '<h3>' + data.l_zniczy + '</h3>';
            output += '<p>zapalonych zniczy</p>'; 
            output += '<a class="hollow button secondary tiny" href="'+wrdPress.homeUrl+'/indeks-nazwisk/"><i class="fa fa-fire" aria-hidden="true"></i>&nbsp; Zapal znicz</a>'; 
        }else{
            output += '<img class="candle-img-xl" src="'+wrdPress.templateUrl+'/img/lanternxl.png">';
            output += '</div>';  
            output += '<p>Brak zapalonych zniczy</p>'; 
            output += '<a class="hollow button secondary tiny" href="'+wrdPress.homeUrl+'/indeks-nazwisk/"><i class="fa fa-fire" aria-hidden="true"></i>&nbsp; Zapal pierwszy znicz</a>'; 
        }       
        output += '</div>';   
        output += '</div>';   

    $('.cwadr-map-list-table').html(output );
}

function fillGraveNone(){
    $('#cwadr-plan-header').html('Kliknij w grób na planie');
    $('#cwadr-plan-grave-content').html('');
}